import api from "../atlasApi";

export const serviceGenerateOsm = (data) => {
  return api.post("/horizon/generate-osm/", data, {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
    },
  });
};


export const serviceCheckProcessing = (data) => {
  return api.post("/horizon/processing-status/", data, {
    headers: {
      Authorization: "Token ea0bb95d88829a5174bae4657242c5c48e121228",
    },
  });
};
